/**
 * 控制序列帧或视频动画
 */
export class FrameAnimation {
  shapeId: string;
  type: 'video' | 'sprite';
  repeatCount = 1;
  repeatedCount = 0;
  status: 'waiting' | 'in-progress' | 'completed' = 'waiting';
  videoEl?: HTMLVideoElement;
  frameIndex = 0;
  frameInterval = 17;
  private nextFrameTime = 0;
  private loopDelay = 0;
  private waitingTime = 0;

  constructor(data: {
    shapeId: string;
    type: FrameAnimation['type'];
    videoEl?: HTMLVideoElement;
    repeatCount: number;
    frameInterval?: number;
  }) {
    const { shapeId, type, videoEl, frameInterval } = data;
    this.shapeId = shapeId;
    this.type = type;
    this.repeatCount = data.repeatCount;

    this.repeatedCount = 0;
    this.videoEl = videoEl;
    if (frameInterval != undefined) this.frameInterval = frameInterval;
  }

  /**
   * 设置下一帧的播放时间
   * @returns
   */
  private setNextFrameTime() {
    this.nextFrameTime = Date.now() + this.frameInterval;
  }

  next() {
    const { status, type, videoEl } = this;
    if (status == 'waiting') {
      if (Date.now() <= this.waitingTime) return;
      if (videoEl) {
        videoEl.currentTime = 0;
        videoEl.play();
      }
      this.frameIndex = 0;
      this.setNextFrameTime();
      this.status = 'in-progress';
    } else if (status == 'in-progress') {
      if (type == 'video') {
        // 视频不需要获取下一帧，只需要保证播放即可
        // 播放在构造函数中处理，这里不重复处理
      } else if (type == 'sprite') {
        // 获取序列帧的图片下标
        const time = Date.now();
        if (time >= this.nextFrameTime) {
          this.frameIndex++;
          this.setNextFrameTime();
        }
      }
    }
  }
  after(spriteTotal?: number) {
    const { status, type, videoEl } = this;
    if (status == 'completed' || status == 'waiting') return;

    // 判断当前循环是否完成
    let loopDone = false;
    if (type == 'video') {
      loopDone = videoEl?.ended ?? true;
    } else if (type == 'sprite') {
      loopDone = this.frameIndex >= (spriteTotal ?? 1) - 1;
    }

    // 如果当前循环完成
    if (loopDone) {
      this.repeatedCount++;
      // 判断是否需要进行下一次循环
      if (this.repeatedCount < this.repeatCount || this.repeatCount == 0) {
        // 重新开始播放
        this.status = 'waiting';
        this.waitingTime = Date.now() + this.loopDelay + this.frameInterval;
      } else {
        this.status = 'completed';
      }
    } else {
      // 还未播放完成，继续播放
    }
  }
}
